/* global jQuery, document */
import map from 'lodash/fp/map';
import hoverintent from 'hoverintent';
import mainMenu from './summit.main-menu';

(($, Drupal) => {
  /* global window, Drupal */
  /* eslint-disable no-param-reassign */
  Drupal.behaviors.summit_theme = {
    attach: () => {
      once('summit_theme', 'body').forEach(() => {

        // Move modals to the end of the body to avoid z-index issues.
        const bsModals = document.querySelectorAll('.modal');
        map(modal => document.body.appendChild(modal), bsModals);

        /**************************************************************************
         * Adds indicator arrows to anchor menu when overflow scroll is present.
         * Shows only left, right, or both arrows based on scroll position.
         **************************************************************************/
        const handleAnchorMenuOverflow = () => {
          document.querySelectorAll('.paragraph--type-anchor-menu').forEach(paragraph => {
            const itemList = paragraph.querySelector('.item-list');
            const ul = itemList?.querySelector('ul');

            if (!ul || !itemList) return;

            // Create arrows if they don't exist.
            let leftArrow = itemList.querySelector('.scroll-arrow.left');
            let rightArrow = itemList.querySelector('.scroll-arrow.right');

            if (!leftArrow) {
              leftArrow = document.createElement('button');
              leftArrow.className = 'scroll-arrow left';
              leftArrow.setAttribute('type', 'button');
              leftArrow.setAttribute('aria-label', 'Scroll left');
              leftArrow.innerHTML = `
                <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 8.013L18.789 8M12.012 15L19 8L12.012 1" stroke="#13294B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="visually-hidden">Scroll left</span>
              `;
              leftArrow.addEventListener('click', () => {
                ul.scrollBy({ left: -200, behavior: 'smooth' });
              });
              itemList.insertBefore(leftArrow, ul);
            }

            if (!rightArrow) {
              rightArrow = document.createElement('button');
              rightArrow.className = 'scroll-arrow right';
              rightArrow.setAttribute('type', 'button');
              rightArrow.setAttribute('aria-label', 'Scroll right');
              rightArrow.innerHTML = `
                <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 8.013L18.789 8M12.012 15L19 8L12.012 1" stroke="#13294B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="visually-hidden">Scroll right</span>
              `;
              rightArrow.addEventListener('click', () => {
                ul.scrollBy({ left: 200, behavior: 'smooth' });
              });
              itemList.appendChild(rightArrow);
            }

            // Hide or show the left/right arrow if there is scrollable content.
            const updateArrowVisibility = () => {
              const scrollLeft = ul.scrollLeft;
              const maxScrollLeft = ul.scrollWidth - ul.clientWidth;

              // Show/hide arrows.
              leftArrow.style.display = scrollLeft > 0 ? 'flex' : 'none';
              rightArrow.style.display = scrollLeft < maxScrollLeft - 1 ? 'flex' : 'none';

              // Show/hide gradients.
              const container = itemList;
              if (scrollLeft <= 0) {
                container.classList.add('hide-left');
              } else {
                container.classList.remove('hide-left');
              }

              if (scrollLeft >= maxScrollLeft - 1) {
                container.classList.add('hide-right');
              } else {
                container.classList.remove('hide-right');
              }
            };

            // Initial check.
            const checkOverflow = () => {
              const isOverflowing = ul.scrollWidth > ul.clientWidth;
              itemList.classList.toggle('is-overflowing', isOverflowing);
              updateArrowVisibility();
            };

            // Bind events.
            ul.addEventListener('scroll', updateArrowVisibility);
            window.addEventListener('resize', checkOverflow);

            // ResizeObserver to handle dynamic width changes.
            if ('ResizeObserver' in window) {
              const resizeObserver = new ResizeObserver(checkOverflow);
              resizeObserver.observe(ul);
            }

            // Run initial check.
            checkOverflow();
          });
        };


        /**************************************************************************
         * Add Play/Pause video button for desktop/mobile for multiple banner types
         **************************************************************************/

        const containers = document.querySelectorAll(
          '.paragraph--type-homepage-banner, .paragraph--type-career-training-banner'
        );

        containers.forEach(container => {
          const videos = container.querySelectorAll('video');
          if (!videos.length) return;

          // Create the toggle button
          const button = document.createElement('button');
          button.classList.add('video-toggle-button', 'pause');
          button.setAttribute('aria-label', 'Pause background video');
          button.innerHTML = 'Pause motion';

          // Append button to container
          container.appendChild(button);

          // Helper to update button state
          function updateButtonState(isPaused) {
            if (isPaused) {
              button.setAttribute('aria-label', 'Play background video');
              button.innerHTML = 'Play video';
              button.classList.remove('pause');
              button.classList.add('play');
            } else {
              button.setAttribute('aria-label', 'Pause background video');
              button.innerHTML = 'Pause motion';
              button.classList.remove('play');
              button.classList.add('pause');
            }
          }

          // Click event toggles videos inside THIS container only
          button.addEventListener('click', () => {
            const isAnyPlaying = Array.from(videos).some(video => !video.paused);

            if (isAnyPlaying) {
              videos.forEach(video => video.pause());
              updateButtonState(true);
            } else {
              videos.forEach(video => video.play());
              updateButtonState(false);
            }
          });
        });


        /**************************************************************************
         * Call anchor menu overflow, mobile menu, and testimonial height set.
         **************************************************************************/
        handleAnchorMenuOverflow();
        mainMenu($);

        /**************************************************************************
         * Keeps focus trapped in the modal so user can only tab to input, search, and close.
         **************************************************************************/
        $('#overlay-search').on('shown.bs.modal', function () {
          const $modal = $(this);
          const focusableSelectors = 'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])';
          const $focusableElements = $modal.find(focusableSelectors).filter(':visible');
          const firstElement = $focusableElements[0];
          const lastElement = $focusableElements[$focusableElements.length - 1];

          // Focus the input field initially
          $modal.find('input.form-search').trigger('focus');

          // Trap focus within modal
          $modal.on('keydown.trapFocus', function (e) {
            if (e.key === 'Tab') {
              if (e.shiftKey) {
                // Shift + Tab
                if (document.activeElement === firstElement) {
                  e.preventDefault();
                  lastElement.focus();
                }
              } else {
                // Tab
                if (document.activeElement === lastElement) {
                  e.preventDefault();
                  firstElement.focus();
                }
              }
            }
          });
        });

        $('#overlay-search').on('hidden.bs.modal', function () {
          $(this).off('keydown.trapFocus'); // Clean up event when modal closes
        });


        /**************************************************************************
         * Add active class to anchor links menu links.
         **************************************************************************/
        if (document.querySelector('ul.anchor-menu-links a[href*="#"]')) {
          $(window).on('popstate load', () => {
            const hashVal = window.location.hash.replace('#', '');
            $('ul.anchor-menu-links a[href*="#"]').each((index, element) => {
              if ($(element).attr('href').replace('#', '') === hashVal) {
                $(element).addClass('active');
              }
              else {
                $(element).removeClass('active');
              }
            });
          });
        }

        /**************************************************************************
         * Add collapsed class to accordion buttons by default.
         **************************************************************************/
        $('.paragraph--type-accordion button.accordion-button').each(function () {
          $(this).addClass('collapsed');
        });

        /**************************************************************************
         * Main menu hovers and keyboard accessibility
         **************************************************************************/
        const dropdowns = document.querySelectorAll('.menu--main .dropdown');
        map((item) => {
          const trigger = item.querySelector('.dropdown-toggle');
          const menu = item.querySelector('.dropdown-menu');
          const links = menu.querySelectorAll('a');
          const hideMenu = () => {
            menu.classList.remove('show');
            menu.parentNode.classList.remove('show');
            trigger.setAttribute('aria-expanded', 'false');
          };
          const showMenu = () => {
            menu.classList.add('show');
            menu.parentNode.classList.add('show');
            trigger.setAttribute('aria-expanded', 'true');
            map((dropdown) => {
              if (dropdown !== item) {
                dropdown.querySelector('.dropdown-toggle').blur();
              }
            }, dropdowns);
          };
          // Hovers
          hoverintent(item, showMenu, hideMenu);
          // Expand dropdown on enter, space, or down arrow
          trigger.addEventListener('keydown', (evt) => {
            switch (evt.keyCode) {
              case 13:
              case 32:
                showMenu();
                evt.stopPropagation();
                evt.preventDefault();
                const first = menu.querySelector('a');
                first.setAttribute('tabindex', '-1');
                if (first) {
                  setTimeout(() => {
                    $(first).focus();
                    first.removeAttribute('tabindex');
                  }, 50);
                }
                break;
              case 38: {
                showMenu();
                evt.stopPropagation();
                evt.preventDefault();
                const menuItems = menu.querySelectorAll('a');
                const last = menuItems[menuItems.length - 1];
                last.setAttribute('tabindex', '-1');
                if (menuItems) {
                  setTimeout(() => {
                    $(last).focus();
                    last.removeAttribute('tabindex');
                  }, 50);
                }
                break;
              }
              case 40: {
                showMenu();
                evt.stopPropagation();
                evt.preventDefault();
                const first = menu.querySelector('a');
                first.setAttribute('tabindex', '-1');
                if (first) {
                  setTimeout(() => {
                    $(first).focus();
                    first.removeAttribute('tabindex');
                  }, 50);
                }
                break;
              }
              default:
                break;
            }
          });
          // Collapse dropdown on ESC and refocus triggering element
          item.addEventListener('keydown', (evt) => {
            switch (evt.keyCode) {
              case 27:
                hideMenu();
                trigger.focus();
                break;
              default:
                break;
            }
          });
          // When a trigger is focused, collapse any dropdown menus that aren't
          // in the same dropdown container. I.e. when tabbing forward to the
          // next top level menu item.
          trigger.addEventListener('focus', () => {
            map((dropdown) => {
              if (dropdown !== item) {
                const m = dropdown.querySelector('.dropdown-menu');
                m.classList.remove('show');
                m.parentNode.classList.remove('show');
                dropdown.querySelector('.dropdown-toggle').setAttribute('aria-expanded', 'false');
              }
            }, dropdowns);
          });
          // Handle arrow navigation on links within dropdowns.
          links.forEach((link, index) => {
            link.addEventListener('keydown', (evt) => {
              switch (evt.keyCode) {
                case 40:
                  $('a', $(evt.target).closest('.dropdown-menu')).eq(index + 1).focus();
                  break;
                case 38: {
                  $('a', $(evt.target).closest('.dropdown-menu')).eq(index - 1).focus();
                  if (index === 0) {
                    hideMenu();
                    trigger.focus();
                  }
                  break;
                }
                case 37: {
                  const $prev = $(evt.target).closest('.dropdown').prev('.dropdown').find('.dropdown-toggle');
                  if ($prev.length) {
                    $prev.focus();
                  } else {
                    hideMenu();
                    document.querySelector('a.navbar-brand').focus();
                  }
                  break;
                }
                case 39: {
                  const $next = $(evt.target)
                    .closest('.dropdown')
                    .next('.dropdown')
                    .find('.dropdown-toggle');
                  if ($next.length) {
                    $next.focus();
                  } else {
                    $(evt.target)
                      .closest('.dropdown')
                      .next('.nav-item')
                      .find('a.menu-level-0')
                      .focus();
                  }
                  break;
                }
                default:
                  break;
              }
            });
          });
          // When gaining focus on a top level link collapse the menu. I.e.
          // when tabbing forward to the next top level item that is not a
          // dropdown.
          const firstTopLink = document.querySelector('a.menu-level-0');
          if (firstTopLink) {
            firstTopLink.addEventListener('focus', hideMenu);
          }

          // Arrow key navigation on top level menu items
          const topLevelLinks = document.querySelectorAll('.menu-level-0');
          if (topLevelLinks.length > 0) {
            map((link) => {
              if (link) {
                link.addEventListener('keydown', (evt) => {
                  switch (evt.keyCode) {
                    case 37:
                      $(evt.target)
                        .closest('.nav-item')
                        .prev('.nav-item')
                        .find('.menu-level-0')
                        .focus();
                      break;
                    case 39:
                      $(evt.target)
                        .closest('.nav-item')
                        .next('.nav-item')
                        .find('.menu-level-0')
                        .focus();
                      break;
                    default:
                      break;
                  }
                });
              }
            }, topLevelLinks);
          }

        }, dropdowns);
      });
    },
  };

})(jQuery, Drupal);
